// Mock data for Illyria Landscape Management - Premium Commercial Focus

export const companyInfo = {
  name: "Illyria Landscape Management",
  tagline: "Your property is an asset. We maintain it that way.",
  description: "Commercial landscape and snow management across Toronto and the Greater Toronto Area.",
  phone: "(905) 887-4303",
  email: "info@illyrialandscape.ca",
  address: "4021 Stouffville Road, Stouffville, Ontario L4A 3X1",
  hours: "Monday - Friday: 7:00 AM - 6:00 PM\nSaturday: 8:00 AM - 4:00 PM\nSunday: Emergency Services Only",
  website: "illyrialandscape.ca",
  serviceArea: "Toronto and the Greater Toronto Area (GTA)"
};

export const services = [
  {
    id: 1,
    title: "Landscape Management",
    description: "Clean, consistent grounds maintenance for commercial properties.",
    image: "https://images.pexels.com/photos/269077/pexels-photo-269077.jpeg"
  },
  {
    id: 2,
    title: "Snow & Ice Management",
    description: "Reliable winter response to maintain access, safety, and site control.",
    image: "https://images.unsplash.com/photo-1608933248052-a943823ca82c"
  },
  {
    id: 3,
    title: "Seasonal Maintenance",
    description: "Spring and fall services to maintain property condition year-round.",
    image: "https://images.unsplash.com/photo-1774423066277-01742038ea5b"
  }
];

export const differentiation = [
  "Consistent execution",
  "Professional presentation",
  "Reliable response",
  "Year-round site control"
];

export const propertyTypes = [
  "Commercial plazas",
  "Industrial and warehouse properties",
  "Multi-building developments",
  "Property managers",
  "Ownership groups"
];

export const serviceAreas = [
  "Toronto",
  "Vaughan",
  "Markham",
  "Richmond Hill",
  "Aurora",
  "Newmarket",
  "Stouffville",
  "North York",
  "Scarborough",
  "Etobicoke",
  "Mississauga",
  "Brampton"
];

export const industries = [
  {
    title: "Commercial Plazas",
    description: "Retail and office complexes that need reliable, professional presentation.",
    icon: "Building2"
  },
  {
    title: "Industrial Properties",
    description: "Warehouses and distribution centers requiring efficient site management.",
    icon: "Factory"
  },
  {
    title: "Multi-Residential",
    description: "Condo and apartment communities with high visibility and resident expectations.",
    icon: "Home"
  },
  {
    title: "Property Portfolios",
    description: "Multi-site management for ownership groups and property managers.",
    icon: "Briefcase"
  }
];

export const whyChoose = [
  {
    title: "Commercial Focus",
    description: "We specialize exclusively in commercial properties. We understand the unique requirements, timelines, and expectations of professional property management.",
    icon: "Target"
  },
  {
    title: "Responsive Service",
    description: "Direct communication, rapid response times, and proactive management. When issues arise, we're on it—no runaround, no excuses.",
    icon: "Zap"
  },
  {
    title: "Year-Round Care",
    description: "Your property doesn't take a break, and neither do we. From spring growth to winter storms, we provide consistent service every season.",
    icon: "Calendar"
  },
  {
    title: "Professional Standards",
    description: "Trained crews, commercial-grade equipment, and documented service delivery. We maintain the level of professionalism your property deserves.",
    icon: "Award"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Thompson",
    role: "Property Manager, Summit Commercial Group",
    content: "Illyria has been managing our portfolio of retail properties for three years now. Their consistency and attention to detail are exactly what we need. No surprises, just reliable service.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "Facilities Director, Cornerstone Industrial",
    content: "When we brought Illyria on board, our site presentation improved immediately. Their team understands the demands of commercial properties and delivers every time.",
    rating: 5
  },
  {
    id: 3,
    name: "David Martinez",
    role: "COO, Heritage Condo Management",
    content: "We manage 12 condo communities, and Illyria handles snow removal for all of them. Their storm response is exceptional—our residents and board members consistently praise their work.",
    rating: 5
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1773578211615-3f162dcb50e5",
    title: "Toronto Commercial Properties",
    category: "Location"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1771547863755-93cd2b3f4ec0",
    title: "Winter Property Maintenance",
    category: "Snow"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1774579893308-ec777199ce32",
    title: "Professional Landscape Care",
    category: "Landscape"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1608933248052-a943823ca82c",
    title: "Commercial Snow Removal",
    category: "Snow"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/2676848/pexels-photo-2676848.jpeg",
    title: "Toronto Downtown Properties",
    category: "Location"
  },
  {
    id: 6,
    url: "https://images.pexels.com/photos/12040655/pexels-photo-12040655.jpeg",
    title: "Commercial Building Maintenance",
    category: "Maintenance"
  }
];

export const faqs = [
  {
    question: "What types of properties do you service?",
    answer: "We specialize exclusively in commercial properties including retail plazas, office complexes, industrial facilities, multi-residential communities, and property portfolios. Our services are designed specifically for the needs of commercial property managers and owners."
  },
  {
    question: "Do you offer emergency snow removal services?",
    answer: "Yes. Our snow and ice management includes 24/7 storm monitoring and emergency response. We maintain crews on standby during winter weather events to ensure your property remains accessible and safe."
  },
  {
    question: "How do you ensure consistent service quality?",
    answer: "We use trained, professional crews with commercial-grade equipment and follow documented service protocols. Each property receives regular site inspections, and we provide detailed service reports to keep you informed."
  },
  {
    question: "Can you manage multiple properties across different locations?",
    answer: "Absolutely. We work with property management companies and ownership groups managing multiple sites. Our systems are built to handle portfolio-level service coordination and reporting."
  },
  {
    question: "What is your response time for service requests?",
    answer: "For routine requests, we respond within 24 hours. For urgent issues affecting safety or property access, we provide same-day response. Winter weather events receive immediate 24/7 attention."
  }
];
